import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isSupportedProviderType(providerType: AttachmentDataProviderType): boolean {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return true;
        case AttachmentDataProviderType.OneDriveConsumer:
            return isFeatureEnabled('doc-link-filePicker');
        default:
            return false;
    }
}
